export function parseSalary(salary: string | undefined) {
  if (!salary) return undefined
  const salaryAmount = salary.replace(',', '.')
  return Number(salaryAmount || undefined)
}
